import { parseErrorsSearch } from '@pa/staff'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { parseActivitySearch } from '@/features/activity'
import { parseProtectionSearch } from '@/features/protection'
import { ClinicDetailPage, isClinicTab, type ClinicDetailSearch } from '@/features/clinic-detail'

/**
 * S-04 Clinic detail, one route per tab (Frontend §7.1). An unknown tab opens Summary. The Errors tab keeps C-03's
 * search params (`range`, `from`, `to`, `code`, `page`, `error`); Activity adds `actor`; Protection adds `decision`
 * (with `range`, `from`, `to`, `page` for its security events, task 16); `notice=impersonation-ended`
 * shows the S-06 return toast.
 */
export const Route = createFileRoute('/_authed/clinics/$clinicId/$tab')({
  validateSearch: (raw: Record<string, unknown>): ClinicDetailSearch => ({
    ...parseErrorsSearch(raw),
    ...parseActivitySearch(raw),
    ...parseProtectionSearch(raw),
    ...(raw.notice === 'impersonation-ended' && { notice: 'impersonation-ended' as const }),
  }),
  beforeLoad: ({ params }) => {
    if (!isClinicTab(params.tab)) {
      redirect({
        to: '/clinics/$clinicId/$tab',
        params: { clinicId: params.clinicId, tab: 'summary' },
        replace: true,
        throw: true,
      })
    }
  },
  component: function ClinicDetailRoute() {
    const { clinicId, tab } = Route.useParams()
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    return (
      <ClinicDetailPage
        clinicId={clinicId}
        tab={isClinicTab(tab) ? tab : 'summary'}
        search={search}
        onSearch={(next, opts) => {
          void navigate({ search: next, replace: opts?.replace ?? false })
        }}
      />
    )
  },
})
